export const language = {
  profile: 'پروفایل',
  management: 'مدیریت',
  cache: 'مدیریت کش',
  banner: 'مدیریت بنر',
  rule: 'مدیریت ریدایرکت',
  security: 'امنیت',
  username: 'نام کاربری',
  password: 'رمز عبور',
  twoFA: 'ورود دو مرحله‌ای',
  logs: 'ورود و خروج',
  trustedDevices: 'دستگاه‌های امن',
  active: 'فعال',
  inactive: 'غیرفعال',
  callInformation: 'اطلاعات تماس',
  phone: 'تلفن',
  email: 'ایمیل',
  address: 'آدرس',
};
